export const variableSymbol = ({ theme: { dimensions } }) => ({
    maxWidth: dimensions.inputMediumMaxWidth,
});
